import React from "react"

const LoginLogo = () => (
    <div className="flex w-full flex-col items-center justify-center p-28 z-50">
        <img src={"./images/logo.svg"} className="h-36" alt={"FINWAY"} />
    </div>
)

export default LoginLogo
